// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_edit.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__section___omifr {
}

.styles__sectionSmall___MrQYN {
}

.styles__tableSection___l7cim {
  margin-bottom: 20px;
  padding-bottom: 10px;
}

.styles__button___ibJgk {
}

.styles__buttonLocal___cYese {
}

.styles__buttonSecondary___f0gHY {
}

.styles__resetSSN___d6Y9P {
  height: 40px;
  line-height: 40px;
  margin-right: 20px;
}

.styles__blocks___PjQbz {
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
}

.styles__block___mDS1Z {
  flex: 0 0 auto;
  margin: 0 1px 1px 0;
}

.styles__normal___hnH0R,
.styles__full___a19w9,
.styles__modal___UT8Vy {
}

.styles__userInfo___et7oD,
.styles__contactInfo___vcWkx,
.styles__addressInfo___JjD3i,
.styles__relationshipInfo___UJltS,
.styles__accountsInfo___JMr0i {
}

.styles__normal___hnH0R .styles__userInfo___et7oD {
    width: calc(100% * 1 / 2 - 1px);
  }

.styles__normal___hnH0R .styles__contactInfo___vcWkx {
    margin-right: 0;
    width: calc(100% * 1 / 2);
  }

.styles__full___a19w9 .styles__userInfo___et7oD {
    width: calc(100% * 1 / 4 - 1px);
  }

.styles__full___a19w9 .styles__contactInfo___vcWkx {
    width: calc(100% * 1 / 4 - 1px);
  }

.styles__full___a19w9 .styles__addressInfo___JjD3i {
    margin-right: 0;
    width: calc(100% * 1 / 2);
  }

.styles__modal___UT8Vy .styles__userInfo___et7oD {
    width: calc(100% * 1 / 5 - 1px);
  }

.styles__modal___UT8Vy .styles__accountsInfo___JMr0i {
    width: calc(100% * 2 / 5 - 1px);
  }

.styles__modal___UT8Vy .styles__addressInfo___JjD3i {
    margin-right: 0;
    width: calc(100% * 2 / 5);
  }

.styles__titleWrapper___vJm3s {
  align-items: center;
  background-color: white;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  font-size: 16px;
  height: 40px;
  margin: 0 0 1px;
  padding: 10px 20px;
  position: relative;
  width: 100%;
}

.styles__refTitle___gNK2c {
  display: inline-block;
  flex: 1;
}

.styles__refTitleRead___xwtUL {
  margin-bottom: 5px;
}

.styles__tabTitle___VtU5Q {
  cursor: pointer;
  margin-right: 20px;
}

.styles__openTitle___dle8O,
.styles__closedTitle___uX7Bv {
}

.styles__closedTitle___uX7Bv {
  opacity: 0.65;
}

.styles__rejectionTitleWrapper___ZYWVx {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  color: white;
}

.styles__rejectionTitle___HmBhu {
  color: white;
}

.styles__rejectionBody___D2iXc {
  border-left: 4px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  margin-bottom: 20px;
}

.styles__row___BuAFt {
  margin-bottom: 10px;
}

.styles__row___BuAFt:last-child {
    margin-bottom: 0;
  }

.styles__rowGroup___VcKsl {
  flex-direction: column;
}

.styles__rowGroup___VcKsl .styles__rowValue___Y7zoz {
    margin-top: 5px;
    width: 100%;
  }

.styles__label___pH3jF {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 10px;
  margin-bottom: 2px;
}

.styles__error___JbuJT {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__table___DmIZJ {
  display: table;
  width: 100%;
}

.styles__thRow___xT8Kg {
  display: table-row;
}

.styles__tdRow___qs1Mh {
  display: table-row;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.styles__tdCell___t0r64 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  display: table-cell;
  padding: 10px;
  vertical-align: top;
}

.styles__thCell___GstXe {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
}

.styles__tableNotes___bAZoD {
  max-height: 300px;
  overflow-y: auto;
  width: 100%;
}

.styles__tableNotes___bAZoD .styles__tdRow___qs1Mh,
  .styles__tableNotes___bAZoD .styles__thRow___xT8Kg {
    display: block;
  }

.styles__tableNotes___bAZoD .styles__tdCell___t0r64,
  .styles__tableNotes___bAZoD .styles__thCell___GstXe {
    display: inline-block;
  }

.styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(2),
    .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(2),
    .styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(3),
    .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(3) {
      width: calc(99.9% * 1/5 - (30px - 30px * 1/5));
    }

.styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(2):nth-child(1n),
    .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(2):nth-child(1n),
    .styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(3):nth-child(1n),
    .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(3):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(2):last-child,
    .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(2):last-child,
    .styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(3):last-child,
    .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(3):last-child {
      margin-right: 0;
    }

.styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(2):nth-child(5n),
    .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(2):nth-child(5n),
    .styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(3):nth-child(5n),
    .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(3):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(2):nth-child(5n + 1),
    .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(2):nth-child(5n + 1),
    .styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(3):nth-child(5n + 1),
    .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(3):nth-child(5n + 1) {
      clear: both;
    }

.styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(1), .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(1) {
      width: calc(99.9% * 3/5 - (30px - 30px * 3/5));
    }

.styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(1):nth-child(1n), .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(1):nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

.styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(1):last-child, .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(1):last-child {
      margin-right: 0;
    }

.styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(1):nth-child(5n), .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(1):nth-child(5n) {
      margin-right: 0;
      float: right;
    }

.styles__tableNotes___bAZoD .styles__tdCell___t0r64:nth-child(1):nth-child(5n + 1), .styles__tableNotes___bAZoD .styles__thCell___GstXe:nth-child(1):nth-child(5n + 1) {
      clear: both;
    }

.styles__tableTickets___z0Yfn {
  max-height: 200px;
  overflow-y: auto;
}

.styles__pending___TuJJi,
.styles__incomplete___MRozm {
}

.styles__active___owh3e,
.styles__approved___GFPkp,
.styles__complete___RI7dl {
}

.styles__closed___a9x5Q,
.styles__rejected___Klj9y {
}

.styles__tableCollapseWrapper___xodMd .styles__tdRow___qs1Mh {
    cursor: pointer;
  }

.styles__tableCollapseWrapper___xodMd[data-active='true'] .styles__tdRow___qs1Mh {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenLight"]};
  }

.styles__tableCollapseWrapper___xodMd[data-active='false'] .styles__tdRow___qs1Mh {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]};
  }

.styles__tableCollapseWrapper___xodMd[data-active='false'] .styles__tdRow___qs1Mh:hover {
      background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenLight"]};
    }

.styles__tableCollapseContent___W2BcX {
  background: rgba(218, 233, 232, 0.5);
  padding: 10px;
}

.styles__sectionTitle___aGj0U,
.styles__titleSection___OXIoB {
  position: relative;
}

.styles__sectionTitle___aGj0U:last-child, .styles__titleSection___OXIoB:last-child {
    margin-bottom: 20px;
  }

.styles__sectionTitle___aGj0U .styles__name___tV1ci, .styles__titleSection___OXIoB .styles__name___tV1ci {
    transition: all 0.25s;
  }

.styles__sectionTitle___aGj0U .styles__noName___z32ZG, .styles__titleSection___OXIoB .styles__noName___z32ZG {
    margin-top: 2px;
  }

.styles__title___ae35n {
  flex: 1;
}

.styles__collapseIcon___IlQKE,
.styles__refEdit___sbIyw {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  background-position: center;
  background-repeat: no-repeat;
  background-size: 28px;
  border-radius: 3px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  height: 40px;
  margin-right: 20px;
  transition: all 0.25s;
  width: 40px;
}

.styles__collapseIcon___IlQKE:hover, .styles__refEdit___sbIyw:hover {
    background-color: #E1DFE1;
    box-shadow: none;
  }

.styles__collapseIcon___IlQKE:last-child, .styles__refEdit___sbIyw:last-child {
    margin-right: 0;
  }

.styles__refEdit___sbIyw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 20px;
}

.styles__editLink___oPBph {
  position: absolute;
  right: 20px;
  top: 12px;
}

.styles__dateStyle___fZvas {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  border: none;
  padding: 0;
}

.styles__dateStyleClosed___eT8nD {
}

.styles__dateStyleClosed___eT8nD .styles__dateTitle___kQ3Va {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__dateStyleActive___L63r6 {
}

.styles__dateStyleActive___L63r6 .styles__dateTitle___kQ3Va {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  }

.styles__dateTitle___kQ3Va {
  background: #E0B641;
  color: white;
  padding: 10px 20px;
}

.rgRow {
    display: flex;
    flex-direction: row;
    margin: 0 -10px;
    padding: 6px 10px;
  }

.rgLabel {
    color: #B6B6B6;
    display: inline-block;
    flex: 0.25;
    font-size: 12px;
    text-align: left;
  }

.rgValue {
    display: inline-block;
    flex: 0.75;
  }

.styles__rowError___Ds6VT {
}

.styles__rowError___Ds6VT .styles__value___gechb,
  .styles__rowError___Ds6VT .styles__label___pH3jF {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__rowError___Ds6VT .styles__error___JbuJT {
    font-weight: bold;
  }

.styles__valueMono___cwXXR {
  font-family: MaisonMono, monospace;
}

.styles__valueBlank___VxQnV {
  color: #EEE;
}

.styles__valueBold___OOiOf {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
  font-weight: bold;
}

.styles__noResults___PYxWF {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
}

.styles__formRefContent___pDOt4 {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.styles__contactBasicFormRef___GdLUx {
  border-top: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  margin-top: 20px;
  padding-top: 20px;
}

.styles__formRefButtons___WagRS {
  display: flex;
  margin-bottom: 10px;
}

.styles__basicEdit___uuVYv {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 20px;
  border-radius: 3px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  height: 30px;
  margin-right: 20px;
  transition: all 0.25s;
  width: 30px;
}

.styles__basicEdit___uuVYv:hover {
    background-color: #E1DFE1;
    box-shadow: none;
  }

.styles__ticketFlag___gQewO {
  display: inline-block;
  margin: 0;
  margin-left: -10px;
  margin-right: 10px;
  max-height: 40px;
  padding: 0;
}

.styles__ticketFlag___gQewO img {
    margin: 0;
    max-height: 40px;
  }

.styles__ticketFlagSmall___lLN4y {
  float: right;
  margin: 0;
  max-height: 25px;
  padding: 0;
  width: 25px;
}

.styles__ticketFlagSmall___lLN4y img {
    max-height: 25px;
  }

.styles__deleteBtn___R9WsY {
}

.styles__buttons___cp7aO {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.styles__removeBtn___DQn9e {
}

.styles__cancelBtn___KLp9P {
}

.styles__spacer___PRoQZ {
  display: inline-block;
  width: 1em;
}

.styles__globalErrors___hZC93 {
  margin-bottom: 20px;
}

.styles__globalErrors___hZC93 h4 {
    margin-bottom: 10px;
  }
`, "",{"version":3,"sources":["webpack://./universal/components/References/MergeContactFormRef/styles.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;AAEA;;AAEA;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;AAIA;;AAEA;;;;;AAMA;;AAGE;IACE,+BAA+B;EACjC;;AAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;AAIA;IACE,+BAA+B;EACjC;;AAEA;IACE,+BAA+B;EACjC;;AAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;AAIA;IACE,+BAA+B;EACjC;;AAEA;IACE,+BAA+B;EACjC;;AAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;AAGF;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;AAGA;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wDAAiB;EACjB,YAAY;AAEd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mEAA4B;EAE5B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AAKrB;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,sBAAsB;AAMxB;;AAJE;IACE,eAAe;IACf,WAAW;EACb;;AAGF;EACE,oDAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mDAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,mDAAc;EAEd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oDAAgB;EAEhB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AAoBb;;AAlBE;;IAEE,cAAc;EAChB;;AAEA;;IAEE,qBAAqB;EAUvB;;AARE;;;;MAEE,8CAAgB;IAClB;;AAHA;;;;MAEE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAHA;;;;MAEE,eAAgB;IAClB;;AAHA;;;;MAEE,eAAgB;MAAhB,YAAgB;IAClB;;AAHA;;;;MAEE,WAAgB;IAClB;;AAEA;MACE,8CAAgB;IAClB;;AAFA;MACE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;AAFA;MACE,eAAgB;IAClB;;AAFA;MACE,eAAgB;MAAhB,YAAgB;IAClB;;AAFA;MACE,WAAgB;IAClB;;AAIJ;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;AAGA;;AAEA;;;AAIA;;AAEA;;AAGA;;AAGE;IACE,eAAe;EACjB;;AAEA;IACE,wDAAwB;EAC1B;;AAEA;IACE,wDAAuB;EAKzB;;AAHE;MACE,wDAAwB;IAC1B;;AAIJ;EACE,oCAAoC;EAEpC,aAAa;AACf;;AAEA;;EAGE,kBAAkB;AAapB;;AAXE;IACE,mBAAmB;EACrB;;AAEA;IACE,qBAAqB;EACvB;;AAEA;IACE,eAAe;EACjB;;AAGF;EACE,OAAO;AACT;;AAEA;;EAEE,8DAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AAUb;;AARE;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;AAEA;IACE,eAAe;EACjB;;AAGF;EACE,yDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,wDAAuB;EACvB,YAAY;EAEZ,UAAU;AACZ;;AAEA;AAMA;;AAHE;IACE,wDAAiB;EACnB;;AAGF;AAMA;;AAHE;IACE,wDAAmB;EACrB;;AAGF;EACE,mBAAmB;EACnB,YAAY;EAEZ,kBAAkB;AACpB;;AAGE;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;AAEA;IACE,cAAc;IACd,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;AAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;AAGF;AAWA;;AARE;;IAEE,mDAAY;EACd;;AAEA;IACE,iBAAiB;EACnB;;AAGF;EAEE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AAEb;;AAEA;EACE,mDAAiB;EAEjB,iBAAiB;AACnB;;AAEA;EACE,oDAAgB;AAElB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kEAAiC;EACjC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8DAAwB;EACxB,yDAAiD;EACjD,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AAMb;;AAJE;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;AAGF;EACE,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AAMZ;;AAJE;IACE,SAAS;IACT,gBAAgB;EAClB;;AAGF;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,WAAW;AAKb;;AAHE;IACE,gBAAgB;EAClB;;AAGF;AAEA;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EAEE,mBAAmB;AAKrB;;AAHE;IACE,mBAAmB;EACrB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtGrayLight, gtGray, gtRed, gtBlue, gtBlueDark, gtBlueLight, gtGreen, gtGreenLight, gtYellowLight, text, textLight from colors;\n\n.section {\n  composes: section from helpers;\n}\n\n.sectionSmall {\n  composes: sectionSmall from helpers;\n}\n\n.tableSection {\n  composes: section;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n}\n\n.button {\n  composes: button from helpers;\n}\n\n.buttonLocal {\n  composes: buttonLocal from helpers;\n}\n\n.buttonSecondary {\n  composes: buttonSecondary from helpers;\n}\n\n.resetSSN {\n  composes: buttonSecondary;\n  height: 40px;\n  line-height: 40px;\n  margin-right: 20px;\n}\n\n.blocks {\n  align-items: stretch;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.block {\n  composes: section from helpers;\n  flex: 0 0 auto;\n  margin: 0 1px 1px 0;\n}\n\n.normal,\n.full,\n.modal {\n  composes: blocks;\n}\n\n.userInfo,\n.contactInfo,\n.addressInfo,\n.relationshipInfo,\n.accountsInfo {\n  composes: block;\n}\n\n.normal {\n  .userInfo {\n    width: calc(100% * 1 / 2 - 1px);\n  }\n\n  .contactInfo {\n    margin-right: 0;\n    width: calc(100% * 1 / 2);\n  }\n}\n\n.full {\n  .userInfo {\n    width: calc(100% * 1 / 4 - 1px);\n  }\n\n  .contactInfo {\n    width: calc(100% * 1 / 4 - 1px);\n  }\n\n  .addressInfo {\n    margin-right: 0;\n    width: calc(100% * 1 / 2);\n  }\n}\n\n.modal {\n  .userInfo {\n    width: calc(100% * 1 / 5 - 1px);\n  }\n\n  .accountsInfo {\n    width: calc(100% * 2 / 5 - 1px);\n  }\n\n  .addressInfo {\n    margin-right: 0;\n    width: calc(100% * 2 / 5);\n  }\n}\n\n.titleWrapper {\n  align-items: center;\n  background-color: white;\n  border-radius: 3px;\n  display: flex;\n  flex-direction: row;\n  font-size: 16px;\n  height: 40px;\n  margin: 0 0 1px;\n  padding: 10px 20px;\n  position: relative;\n  width: 100%;\n}\n\n.refTitle {\n  display: inline-block;\n  flex: 1;\n}\n\n.refTitleRead {\n  margin-bottom: 5px;\n}\n\n.tabTitle {\n  composes: refTitle;\n  cursor: pointer;\n  margin-right: 20px;\n}\n\n.openTitle,\n.closedTitle {\n  composes: tabTitle;\n}\n\n.closedTitle {\n  opacity: 0.65;\n}\n\n.rejectionTitleWrapper {\n  background: gtRed;\n  color: white;\n  composes: sectionTitle from helpers;\n}\n\n.rejectionTitle {\n  color: white;\n}\n\n.rejectionBody {\n  border-left: 4px solid gtRed;\n  composes: section from helpers;\n  margin-bottom: 20px;\n}\n\n.row {\n  margin-bottom: 10px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.rowGroup {\n  flex-direction: column;\n\n  .rowValue {\n    margin-top: 5px;\n    width: 100%;\n  }\n}\n\n.label {\n  color: textLight;\n  font-size: 10px;\n  margin-bottom: 2px;\n}\n\n.error {\n  color: gtRed;\n}\n\n.table {\n  display: table;\n  width: 100%;\n}\n\n.thRow {\n  display: table-row;\n}\n\n.tdRow {\n  display: table-row;\n  text-decoration: none;\n}\n\n.tdCell {\n  color: gtGreen;\n  composes: clearfix from helpers;\n  display: table-cell;\n  padding: 10px;\n  vertical-align: top;\n}\n\n.thCell {\n  color: textLight;\n  composes: tdCell;\n  font-size: 12px;\n}\n\n.tableNotes {\n  max-height: 300px;\n  overflow-y: auto;\n  width: 100%;\n\n  .tdRow,\n  .thRow {\n    display: block;\n  }\n\n  .tdCell,\n  .thCell {\n    display: inline-block;\n\n    &:nth-child(2),\n    &:nth-child(3) {\n      lost-column: 1/5;\n    }\n\n    &:nth-child(1) {\n      lost-column: 3/5;\n    }\n  }\n}\n\n.tableTickets {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.pending,\n.incomplete {\n  composes: statusPending from helpers;\n}\n\n.active,\n.approved,\n.complete {\n  composes: statusActive from helpers;\n}\n\n.closed,\n.rejected {\n  composes: statusRejected from helpers;\n}\n\n.tableCollapseWrapper {\n  .tdRow {\n    cursor: pointer;\n  }\n\n  &[data-active='true'] .tdRow {\n    background: gtGreenLight;\n  }\n\n  &[data-active='false'] .tdRow {\n    background: gtGrayLight;\n\n    &:hover {\n      background: gtGreenLight;\n    }\n  }\n}\n\n.tableCollapseContent {\n  background: rgba(218, 233, 232, 0.5);\n  composes: clearfix from helpers;\n  padding: 10px;\n}\n\n.sectionTitle,\n.titleSection {\n  composes: sectionTitle row from helpers;\n  position: relative;\n\n  &:last-child {\n    margin-bottom: 20px;\n  }\n\n  .name {\n    transition: all 0.25s;\n  }\n\n  .noName {\n    margin-top: 2px;\n  }\n}\n\n.title {\n  flex: 1;\n}\n\n.collapseIcon,\n.refEdit {\n  background-color: gtGray;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 28px;\n  border-radius: 3px;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 40px;\n  margin-right: 20px;\n  transition: all 0.25s;\n  width: 40px;\n\n  &:hover {\n    background-color: #E1DFE1;\n    box-shadow: none;\n  }\n\n  &:last-child {\n    margin-right: 0;\n  }\n}\n\n.refEdit {\n  background-image: url(\"styles/img/icon_edit.png\");\n  background-size: 20px;\n}\n\n.editLink {\n  position: absolute;\n  right: 20px;\n  top: 12px;\n}\n\n.dateStyle {\n  background: gtBlueLight;\n  border: none;\n  composes: section;\n  padding: 0;\n}\n\n.dateStyleClosed {\n  composes: dateStyle;\n\n  .dateTitle {\n    background: gtRed;\n  }\n}\n\n.dateStyleActive {\n  composes: dateStyle;\n\n  .dateTitle {\n    background: gtGreen;\n  }\n}\n\n.dateTitle {\n  background: #E0B641;\n  color: white;\n  composes: sectionSmall;\n  padding: 10px 20px;\n}\n\n:global {\n  .rgRow {\n    display: flex;\n    flex-direction: row;\n    margin: 0 -10px;\n    padding: 6px 10px;\n  }\n\n  .rgLabel {\n    color: #B6B6B6;\n    display: inline-block;\n    flex: 0.25;\n    font-size: 12px;\n    text-align: left;\n  }\n\n  .rgValue {\n    display: inline-block;\n    flex: 0.75;\n  }\n}\n\n.rowError {\n  composes: row;\n\n  .value,\n  .label {\n    color: gtRed;\n  }\n\n  .error {\n    font-weight: bold;\n  }\n}\n\n.valueMono {\n  composes: value;\n  font-family: MaisonMono, monospace;\n}\n\n.valueBlank {\n  color: #EEE;\n  composes: value;\n}\n\n.valueBold {\n  color: gtBlueDark;\n  composes: value;\n  font-weight: bold;\n}\n\n.noResults {\n  color: textLight;\n  composes: section from helpers;\n}\n\n.formRefContent {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n}\n\n.contactBasicFormRef {\n  border-top: 1px solid gtBlueLight;\n  margin-top: 20px;\n  padding-top: 20px;\n}\n\n.formRefButtons {\n  display: flex;\n  margin-bottom: 10px;\n}\n\n.basicEdit {\n  background-color: gtGray;\n  background-image: url(\"styles/img/icon_edit.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 20px;\n  border-radius: 3px;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 30px;\n  margin-right: 20px;\n  transition: all 0.25s;\n  width: 30px;\n\n  &:hover {\n    background-color: #E1DFE1;\n    box-shadow: none;\n  }\n}\n\n.ticketFlag {\n  display: inline-block;\n  margin: 0;\n  margin-left: -10px;\n  margin-right: 10px;\n  max-height: 40px;\n  padding: 0;\n\n  & img {\n    margin: 0;\n    max-height: 40px;\n  }\n}\n\n.ticketFlagSmall {\n  float: right;\n  margin: 0;\n  max-height: 25px;\n  padding: 0;\n  width: 25px;\n\n  & img {\n    max-height: 25px;\n  }\n}\n\n.deleteBtn {\n  composes: buttonDanger from helpers;\n}\n\n.buttons {\n  align-items: center;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.removeBtn {\n  composes: buttonDanger from helpers;\n}\n\n.cancelBtn {\n  composes: button from helpers;\n}\n\n.spacer {\n  display: inline-block;\n  width: 1em;\n}\n\n.globalErrors {\n  composes: error;\n  margin-bottom: 20px;\n\n  h4 {\n    margin-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtGreenLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenLight"]}`,
	"gtYellowLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"section": `styles__section___omifr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"sectionSmall": `styles__sectionSmall___MrQYN ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"tableSection": `styles__tableSection___l7cim styles__section___omifr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"button": `styles__button___ibJgk ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"buttonLocal": `styles__buttonLocal___cYese ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonLocal"]}`,
	"buttonSecondary": `styles__buttonSecondary___f0gHY ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"resetSSN": `styles__resetSSN___d6Y9P styles__buttonSecondary___f0gHY ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"blocks": `styles__blocks___PjQbz`,
	"block": `styles__block___mDS1Z ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"normal": `styles__normal___hnH0R styles__blocks___PjQbz`,
	"full": `styles__full___a19w9 styles__blocks___PjQbz`,
	"modal": `styles__modal___UT8Vy styles__blocks___PjQbz`,
	"userInfo": `styles__userInfo___et7oD styles__block___mDS1Z ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"contactInfo": `styles__contactInfo___vcWkx styles__block___mDS1Z ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"addressInfo": `styles__addressInfo___JjD3i styles__block___mDS1Z ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"relationshipInfo": `styles__relationshipInfo___UJltS styles__block___mDS1Z ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"accountsInfo": `styles__accountsInfo___JMr0i styles__block___mDS1Z ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"titleWrapper": `styles__titleWrapper___vJm3s`,
	"refTitle": `styles__refTitle___gNK2c`,
	"refTitleRead": `styles__refTitleRead___xwtUL`,
	"tabTitle": `styles__tabTitle___VtU5Q styles__refTitle___gNK2c`,
	"openTitle": `styles__openTitle___dle8O styles__tabTitle___VtU5Q styles__refTitle___gNK2c`,
	"closedTitle": `styles__closedTitle___uX7Bv styles__tabTitle___VtU5Q styles__refTitle___gNK2c`,
	"rejectionTitleWrapper": `styles__rejectionTitleWrapper___ZYWVx ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"rejectionTitle": `styles__rejectionTitle___HmBhu`,
	"rejectionBody": `styles__rejectionBody___D2iXc ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"row": `styles__row___BuAFt`,
	"rowGroup": `styles__rowGroup___VcKsl`,
	"rowValue": `styles__rowValue___Y7zoz`,
	"label": `styles__label___pH3jF`,
	"error": `styles__error___JbuJT`,
	"table": `styles__table___DmIZJ`,
	"thRow": `styles__thRow___xT8Kg`,
	"tdRow": `styles__tdRow___qs1Mh`,
	"tdCell": `styles__tdCell___t0r64 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"thCell": `styles__thCell___GstXe styles__tdCell___t0r64 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"tableNotes": `styles__tableNotes___bAZoD`,
	"tableTickets": `styles__tableTickets___z0Yfn`,
	"pending": `styles__pending___TuJJi ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"incomplete": `styles__incomplete___MRozm ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"active": `styles__active___owh3e ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"approved": `styles__approved___GFPkp ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"complete": `styles__complete___RI7dl ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"closed": `styles__closed___a9x5Q ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"rejected": `styles__rejected___Klj9y ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"tableCollapseWrapper": `styles__tableCollapseWrapper___xodMd`,
	"tableCollapseContent": `styles__tableCollapseContent___W2BcX ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"sectionTitle": `styles__sectionTitle___aGj0U ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"titleSection": `styles__titleSection___OXIoB ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"name": `styles__name___tV1ci`,
	"noName": `styles__noName___z32ZG`,
	"title": `styles__title___ae35n`,
	"collapseIcon": `styles__collapseIcon___IlQKE`,
	"refEdit": `styles__refEdit___sbIyw`,
	"editLink": `styles__editLink___oPBph`,
	"dateStyle": `styles__dateStyle___fZvas styles__section___omifr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"dateStyleClosed": `styles__dateStyleClosed___eT8nD styles__dateStyle___fZvas styles__section___omifr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"dateTitle": `styles__dateTitle___kQ3Va styles__sectionSmall___MrQYN ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"dateStyleActive": `styles__dateStyleActive___L63r6 styles__dateStyle___fZvas styles__section___omifr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"rowError": `styles__rowError___Ds6VT styles__row___BuAFt`,
	"value": `styles__value___gechb`,
	"valueMono": `styles__valueMono___cwXXR styles__value___gechb`,
	"valueBlank": `styles__valueBlank___VxQnV styles__value___gechb`,
	"valueBold": `styles__valueBold___OOiOf styles__value___gechb`,
	"noResults": `styles__noResults___PYxWF ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"formRefContent": `styles__formRefContent___pDOt4`,
	"contactBasicFormRef": `styles__contactBasicFormRef___GdLUx`,
	"formRefButtons": `styles__formRefButtons___WagRS`,
	"basicEdit": `styles__basicEdit___uuVYv`,
	"ticketFlag": `styles__ticketFlag___gQewO`,
	"ticketFlagSmall": `styles__ticketFlagSmall___lLN4y`,
	"deleteBtn": `styles__deleteBtn___R9WsY ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"buttons": `styles__buttons___cp7aO`,
	"removeBtn": `styles__removeBtn___DQn9e ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"cancelBtn": `styles__cancelBtn___KLp9P ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"spacer": `styles__spacer___PRoQZ`,
	"globalErrors": `styles__globalErrors___hZC93 styles__error___JbuJT`
};
export default ___CSS_LOADER_EXPORT___;
